import React from 'react'
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";


function ProductCard({ product, index }) {
  return (
   <div className="featured-product bg-white shadow-lg rounded-lg overflow-hidden" key={index}>
      <div className="relative w-full" style={{ paddingBottom: "100%" }}>
        <Link to={`/products/${product?._id}`}>
          <Image
            src={
              product?.image[0]
                ? product?.image[0]
                : "../images/1.jpg"
            }
            alt={product?.name}
            className="absolute inset-0 w-full h-full object-cover rounded-t-lg"
          />
        </Link>
      </div>
      <div className="p-4 text-data">
        <h3 className="text-lg font-semibold mb-2">
          <Link
            to={`/products/${product?._id}`}
            className="hover:text-blue-600"
          >
            {product?.name}
          </Link>
        </h3>
        <p className="text-sm text-gray-700 mb-4">{product?.description}</p>
        <Link
          to={`/products/${product?._id}`}
          className="text-blue-600 hover:text-blue-800 text-sm"
        >
          Know More
        </Link>
      </div>
    </div>
  );
}

export default ProductCard
